import * as yup from 'yup';
import { FileUtil, FormValidationUtil } from '../../../utils';

export const documentHeaders = [
  'Document Type',
  'Document Name',
  'Uploaded By',
  'Date',
];

export const documentInitialValues = {
  documentType: '',
  file: [],
  comments: '',
};

export const validationSchema = yup.object().shape({
  documentType: yup.string().required('Document Type is required'),
  comments: yup.string().optional(),
  file: yup
    .array()
    .min(1, 'Attachment is required')
    .test(
      'fileSize',
      `File size must be less than ${FileUtil.DEFAULT_ATTACHMENT_SIZE_MB}MB`,
      FormValidationUtil.validateMultipleFilesSize(
        FileUtil.DEFAULT_ATTACHMENT_SIZE_B,
      ),
    )
    .test(
      'fileFormat',
      FormValidationUtil.validateMultipleFilesFormatMessage(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
      FormValidationUtil.validateMultipleFilesFormat(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
    ),
});

export const documentTypeOptions = [
  { value: 'Passport', label: 'Passport' },
  { value: 'Visa', label: 'Visa' },
  { value: 'Flight Ticket', label: 'Flight Ticket' },
  { value: 'Hotel Booking', label: 'Hotel Booking' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Other', label: 'Other' },
];
